import { Color, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { ReportRowType } from '../../types/reportRowType'
import { getFooterCellStyles } from '../../utils/getFooterCellStyles'
import { getStickyCellStyles } from '../../utils/getStickyCellStyles'
import { getTableCellStyles } from '../../utils/getTableCellStyles'

interface TableRowProps {
  clickable?: boolean
  expanded?: boolean
  nested?: boolean
  type?: ReportRowType
}

const getClickableStyles = () => css`
  cursor: pointer;
  &:hover {
    background-color: ${Color.Grey50};

    /* Ensure sticky first column also gets hover background */
    td:first-of-type {
      background-color: ${Color.Grey50};
    }
  }
`

const getNestedStyles = () => css`
  background-color: ${Color.Grey100};

  /* Ensure sticky first column also gets nested background */
  td:first-of-type {
    background-color: ${Color.Grey100};
  }
`

const getExpandedRowStyles = () => css`
  & + tr {
    box-shadow: inset 0 8px 8px -4px ${Color.Grey150};

    /* Ensure sticky first column also gets the expanded shadow */
    td:first-of-type {
      box-shadow: inset 0 8px 8px -4px ${Color.Grey150};
    }
  }
`

const getHeaderStyles = () => css`
  &:not(:first-child) {
    border-top: 2px solid ${Color.Black};
  }
`

const getFooterStyles = () => css`
  border-top: 2px solid ${Color.Black};
`

export const TableRow = styled.tr<TableRowProps>`
  position: relative;

  &:not(:last-child) {
    border-bottom: 1px solid ${Color.Grey150};
  }

  ${({ clickable }) => clickable && getClickableStyles()};
  ${({ nested }) => nested && getNestedStyles()};
  ${({ expanded }) => expanded && getExpandedRowStyles()};
  ${({ type }) => type === ReportRowType.Header && getHeaderStyles()};
  ${({ type }) => type === ReportRowType.Footer && getFooterStyles()};
`

export const GroupHeaderCell = styled.td`
  ${getStickyCellStyles()};
  display: flex;
  flex-direction: column;
  padding-top: ${Spacing.S32};
  padding-bottom: ${Spacing.S24};
  padding-inline: ${Spacing.S40};
`

export const ExpandableHeader = styled.td`
  ${getStickyCellStyles()};
  padding: ${Spacing.S16} ${Spacing.S16};
  background-color: ${Color.White};

  svg {
    flex-shrink: 0;
  }
`

export const TableCell = styled.td`
  ${getTableCellStyles()};
  ${getStickyCellStyles()};
`

export const FooterCell = styled.td`
  ${getFooterCellStyles()};
  ${getStickyCellStyles()};
  padding-left: ${Spacing.S40};
`

/* Hack for truncating text within flex container */
export const TruncatedTextWrapper = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`
